// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__qIEbS","name":"ConsentHeader_name__6MJes","birthday":"ConsentHeader_birthday__2hkqj","skeleton":"ConsentHeader_skeleton__W9g7n"};